import createContextUtilities from '../../utils/createContextUtilities/3841674170c200f7bdd32cb74e68b517c71ba9e78ccd1beac3d76de81e3e2a5c.cfe-internal.js';

// need to access util directly to avoid circular dependency

var _createContextUtiliti = createContextUtilities(typeof window !== 'undefined' ? document.body : null),
    PortalTargetProvider = _createContextUtiliti.Provider,
    usePortalTarget = _createContextUtiliti.useContext;

export { PortalTargetProvider, usePortalTarget };
